import _ from 'lodash';
import type { CountriesQuery, CountriesQueryVariables } from '@/shared/api/__generated__/graphql';
import createClient from '../apolloClient';
import COUNTRIES_QUERY from '../queries/countries';

/**
 * Retrieves the country list used by address and facility forms. Runs the countries GraphQL query on a cache-enabled client and throws the first GraphQL error when no countries came back.
 *
 * @returns List of countries returned by the query.
 */
const fetchCountries = async () => {
  const client = createClient({ isUsingCache: true });
  const countriesResult = await client.query<CountriesQuery, CountriesQueryVariables>({
    query: COUNTRIES_QUERY,
  });
  const { data, errors } = countriesResult;
  const { countries } = data;
  if (_.isNil(countries) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return countries;
};

export default fetchCountries;
